// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import  VueGtag from "vue-gtag"

import { store } from './store';
console.log("window")
console.log(window.Vue)
Vue.config.productionTip = false;
Vue.use(VueGtag, {
  config: { 
    id: "G-89QF18M7CT",
    params: {
      send_page_view: true
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router, 
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js